import { Facebook, Linkedin, Youtube } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface SocialLink {
  label: string;
  href: string;
  icon: LucideIcon | null;
  iconType?: "tiktok" | "whatsapp" | "instagram";
}

export const socialLinks: SocialLink[] = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/supremeturf.au",
    icon: Facebook,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/supreme.turf/",
    icon: null,
    iconType: "instagram",
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@supreme.turf",
    icon: null,
    iconType: "tiktok",
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@supremeturf",
    icon: Youtube,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/supremeturf/",
    icon: Linkedin,
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/61457585901",
    icon: null,
    iconType: "whatsapp",
  },
];
